<div class="kt-portlet container">
	<div class="kt-portlet__head">
		<div class="encabezado mt-3">
			<h1 class="titulo"><i class="fas fa-camera"></i>&nbsp;Fotografias</h1>
		</div>
	</div>
	<mat-divider></mat-divider>
	<div class="kt-portlet__body">
		<div class="row">
			<div class="col-md-4 form-group">
				<i class="fas fa-barcode-scan"></i>&nbsp;
				<label for="imei">IMEI</label>
				<input id="imei" type="text" class="form-control" [formControl]="imeiControl"
					[matAutocomplete]="autoImei">
				<mat-autocomplete #autoImei="matAutocomplete">
					<mat-option *ngFor="let imei of filteredOptions | async" [value]="imei">
						{{imei}}
					</mat-option>
				</mat-autocomplete>
			</div>
			<div class="col-md-6 mt-3 form-group">
				<button id="agregarBoton" mat-raised-button class="btn btn-success mt-3" (click)="getImagesList()"
					style="margin-right: 15px;"><i class="fas fa-search"></i>&nbsp;Buscar</button>&nbsp;
				<button id="agregarBoton" mat-raised-button class="btn btn-success mt-3" (click)="getImagesList()"
					style="margin-right: 15px;"><i class="fas fa-sync-alt"></i>&nbsp;Actualizar</button>&nbsp;
				<button mat-raised-button (click)="regresar()"><i class="fas fa-long-arrow-alt-left"></i>&nbsp;Regresar</button>

			</div>
		</div>
		<div class="kt-section">
			<div class="kt-section__content">
				<div class="contenedor-modal">
					<div class="data-grid">
						<dx-data-grid id="gridContainer" [columnHidingEnabled]="true" [dataSource]="imagesList"
							[showBorders]="true">
							<dxo-paging [pageSize]="7"></dxo-paging>
							<dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[7, 10, 50, 100]"
								[showInfo]="true">
							</dxo-pager>
							<dxo-group-panel [emptyPanelText]="mensajeAgrupar" [visible]="true"></dxo-group-panel>
							<dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>
							<dxi-column caption="Acciones" cellTemplate="acciones" alignment="center" [width]="100">
							</dxi-column>
							<dxi-column dataField="id" caption="Imagen" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column [(filterValue)]="filterValue" dataField="fecha" caption="Fecha" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<dxi-column dataField="hora" caption="Hora" alignment="center">
								<dxo-header-filter [allowSearch]="true"></dxo-header-filter>
							</dxi-column>
							<div *dxTemplate="let row of 'acciones'">
								<ng-container>
									<dx-button valueExpr="id" id="botonWhiteBlue" class="btnAcciones"
										(click)="getImage(row.data)">
										<i class="fas fa-eye"></i>
									</dx-button>
								</ng-container>
							</div>
						</dx-data-grid>

					</div>
				</div>
			</div>
		</div>

	</div>
</div>

<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadingVisible" [showIndicator]="true"
	[showPane]="true" [shading]="true" [closeOnOutsideClick]="false" message="Cargando...">
</dx-load-panel>
